import { theme } from 'core/Theming/theme';
import { DataGridTypes } from 'devextreme-react/cjs/data-grid';
import { DataGridCell } from 'devextreme-react/cjs/common/export/pdf';

export const valuesConverter = (data: any[]) => {
  return data.map((row) => {
    return {
      ...row,
      affectsCycleTime: row.affectsCycleTime == 0 ? 'No' : 'Yes',
    };
  });
};

export const cellPrepared = (e: DataGridTypes.CellPreparedEvent) => {
  if (e.column.dataField === 'affectsCycleTime' && e.rowType === 'data') {
   const className = e.value === 'Yes' ? 'green' : 'pink';
   e.cellElement.classList.add(className);
  }
};

export const customizeCell = ({
  gridCell,
  excelCell,
}: {
  gridCell?: DataGridCell;
  excelCell?: any;
}) => {
  if (gridCell?.column?.dataField === 'affectsCycleTime' && gridCell?.rowType === 'data') {
    const colorName = gridCell.value === 'Yes' ? 'green' : 'pink';
    excelCell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {
        argb: theme.palette.reports[colorName]?.replace('#', ''),
      },
    };
  }
};

